import React, { useCallback } from 'react';
import ModalBS from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
// import usePrevious from './usePrevious';

// function isModalClosed(modalState, prevModalState) {
//     return modalState && prevModalState && modalState.visible === false && prevModalState.visible === true;
// }

interface ModalProps {
    name: string
    title: string
    size?: 'sm' | 'lg' | 'xl';
    visible: boolean
    onClose?: () => void
}

const Modal: React.FC<ModalProps> = ({ name, title, size, visible, onClose, children }) => {
    // const modalState = useSelector(state => state.modals[name]);
    // const dispatch = useDispatch();
    // const hideModal = useCallback(() => dispatch({ type: 'HIDE_MODAL', name }), []);
    const hideModal = useCallback(() => { }, []);
    // const prevModalState = usePrevious(modalState);
    // onClose && isModalClosed(modalState, prevModalState) && onClose();
    return (
        <ModalBS backdrop scrollable show={visible} onHide={hideModal} size={size}>
            <ModalBS.Header closeButton onHide={onClose}>
                <ModalBS.Title as="h4">{title}</ModalBS.Title>
            </ModalBS.Header>
            {children}
        </ModalBS>
    );
};

interface OkButtonProps {
    name: string
    disabled?: boolean
    onOk: () => void
}

export const OkButton: React.FC<OkButtonProps> = ({ name, onOk, disabled }) => {
    const onClickHandler = useCallback(() => {
        onOk && onOk();
    }, [onOk]);
    return (
        <Button className="btn-modal-action" variant="default" onClick={onClickHandler} disabled={disabled}>OK</Button>
    );
};


interface CancelButtonProps {
    name: string
    label?: string
    disabled?: boolean
    onCancel: () => void
}

export const CancelButton: React.FC<CancelButtonProps> = ({ name, label, onCancel, disabled }) => {
    const onClickHandler = useCallback(() => {
        onCancel && onCancel();
    }, [onCancel]);
    return (
        <Button className="btn-modal-action" variant="default" onClick={onClickHandler} disabled={disabled}>{label || 'Cancel'}</Button>
    );
};

interface SaveButtonProps {
    name: string
    label?: string
    disabled?: boolean
    onSave: () => void
}

export const SaveButton: React.FC<SaveButtonProps> = ({ name, label, onSave, disabled }) => {
    const onClickHandler = useCallback(() => {
        onSave && onSave();
    }, [onSave]);
    return (
        <Button className="btn-modal-action" variant="default" onClick={onClickHandler} disabled={disabled}>{label || 'Save'}</Button>
    );
};

export default Modal
